/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Medal3: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M12 18C9.748 18 7.674 17.242 6 15.981V24L12 21L18 24V15.981C16.326 17.242 14.252 18 12 18Z' fill='currentColor' />
    <path d='M12 16C16.4183 16 20 12.4183 20 8C20 3.58172 16.4183 0 12 0C7.58172 0 4 3.58172 4 8C4 12.4183 7.58172 16 12 16Z' fill='currentColor' />
  </React.Fragment>
)
